function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createClient } from 'contentful';
import { logError } from '@cbhq/cdx-components';
const previewClients = {};
let defaultClient;
const initContentfulClient = ({
  config,
  previewConfig
}) => {
  defaultClient = createClient(config);
  if (previewConfig && previewConfig.accessToken) {
    const key = previewConfig.environment ?? 'master';
    previewClients[key] = {
      client: createClient(previewConfig),
      params: previewConfig
    };
    if (!previewClients.default) {
      previewClients.default = previewClients[key];
    }
  }
};
const getContentEntry = async (params, shouldThrowError) => {
  const results = await getContentEntries(_objectSpread(_objectSpread({}, params), {}, {
    queryParams: _objectSpread(_objectSpread({}, params.queryParams), {}, {
      limit: 1
    })
  }), shouldThrowError);
  return results && results?.items ? results.items[0] : null;
};
const getContentEntries = async ({
  isPreview,
  env = 'default',
  locale,
  tagId,
  slug,
  contentType = 'page',
  queryParams = {}
}, shouldThrowError) => {
  let client = defaultClient;
  if (isPreview) {
    client = previewClients[env]?.client;
    if (!client && previewClients.default) {
      initContentfulClient({
        config: _objectSpread(_objectSpread({}, previewClients.default.params), {}, {
          environment: env
        })
      });
      client = previewClients[env].client;
    }
  }
  try {
    const query = _objectSpread(_objectSpread(_objectSpread({
      include: 10,
      locale,
      content_type: contentType
    }, slug && {
      'fields.slug': slug
    }), tagId && {
      'metadata.tags.sys.id[all]': tagId
    }), queryParams);
    const result = await client.getEntries(query);
    if (result.items.length > 0) {
      // see: https://jira.coinbase-corp.com/browse/GROW-7619
      // and: https://github.com/contentful/contentful.js/issues/377
      const _JSON$parse = JSON.parse(result.stringifySafe()),
        items = _JSON$parse.items,
        total = _JSON$parse.total,
        skip = _JSON$parse.skip;
      return {
        items,
        total,
        skip
      };
    }
    return null;
  } catch (e) {
    if (shouldThrowError) throw e;
    logError('error', e);
    return null;
  }
};
const getAllContentEntries = async (params, shouldThrowError) => {
  const limit = params?.queryParams?.limit || 100;
  let skip = 0;
  let total = 1;
  let items = [];
  while (skip < total) {
    const query = _objectSpread(_objectSpread({}, params), {}, {
      queryParams: _objectSpread(_objectSpread({}, params.queryParams), {}, {
        limit,
        skip
      })
    });
    const entries = await getContentEntries(query, shouldThrowError);
    if (!entries) break;
    total = entries.total;
    skip = entries.skip + limit;
    items = items.concat(entries.items);
  }
  if (items.length === 0) return null;
  return {
    items,
    total
  };
};
export { getAllContentEntries, getContentEntries, getContentEntry, initContentfulClient };
//# sourceMappingURL=client.js.map
